import React from "react";
import { TextInput } from "components/flexible_testing/shared/form";
import { useFormikContext } from "formik";
import { RequestedTest } from "components/flexible_testing/test_request_page/requested_test_page/requested_test_form";

const TestCasesUrl = () => {
  const { values } = useFormikContext<RequestedTest>();

  return (
    <div className="mt-md">
      <div>
        <TextInput
          name="testCasesUrl"
          placeholder="http://www.your-test-cases.com"
          label="Link to test cases sheet"
          labelClass="font-normal"
          required
        />
      </div>
      <div className="mt-md">
        <TextInput
          name="numberOfResultsPerTestCaseNeeded"
          value={values.numberOfResultsPerTestCaseNeeded}
          label="How many results do you need for each test case?"
          labelClass="font-normal"
          required
        />
      </div>
    </div>
  );
};

export default TestCasesUrl;
